"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _2 = require("../..");

var _mobxReact = require("mobx-react");

var _lodash = _interopRequireDefault(require("lodash"));

var _flex = _interopRequireDefault(require("../../design-system/flex"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./FileUpload.css");

var _styles = {
  "error-message": "FileUpload__error-message___1MBZ8",
  "error-label": "FileUpload__error-label___3e0FT",
  "file-upload-results": "FileUpload__file-upload-results___4dFTB",
  "result-row": "FileUpload__result-row___1CcRm",
  "result-row-name": "FileUpload__result-row-name___1NdlE",
  "in-progress": "FileUpload__in-progress___2-HMF",
  "file-name": "FileUpload__file-name___A0sUn",
  "result-row-info": "FileUpload__result-row-info___3MYGB",
  "file-upload-button": "FileUpload__file-upload-button___2BDhX"
};

const styles = _bind.default.bind(_styles);

const FileUpload = (0, _mobxReact.observer)(({
  allowFilePassword,
  alignItems = 'center',
  dataTestId,
  error,
  errorText,
  maxFileSize = 1024 * 1024 * 25,
  acceptedFiletypes,
  onError,
  onPasswordProtectedError,
  onFileAdded,
  onFileCancelled,
  onFileRemoved,
  onFileProgressCompleted,
  title,
  subtitle,
  flexDirection = 'row',
  label,
  bgColor,
  previouslyUploadedFiles
}) => {
  const [fileList, setFileList] = (0, _react.useState)([]);
  const inputRef = (0, _react.createRef)();
  const isFlexDirectionColumn = flexDirection === 'column';

  const removeFile = fileToRemove => {
    var _a;

    if (!fileToRemove.error && !fileToRemove.isUploaded) {
      fileToRemove.setError(`Upload has been cancelled.`);
      (_a = fileToRemove.abortController) === null || _a === void 0 ? void 0 : _a.abort();
      fileToRemove.setAbortController(null);

      if (onFileCancelled) {
        onFileCancelled(fileToRemove, fileList);
      }
    } else if (fileList.includes(fileToRemove)) {
      fileList.splice(fileList.indexOf(fileToRemove), 1);
      setFileList([...fileList]);

      if (onFileRemoved) {
        onFileRemoved(fileToRemove, fileList);
      }
    }

    if (inputRef.current) {
      inputRef.current.value = '';
    }
  };

  return _react.default.createElement(_2.Card, {
    className: styles('file-upload'),
    dataTestId: dataTestId,
    noMargin: true
  }, _react.default.createElement(_2.Content, {
    flex: true,
    flexDirection: flexDirection,
    paddingTopBottom: 16,
    paddingLeftRight: 24,
    bgColor: bgColor ? bgColor : _2.Color.neutral._light_20,
    alignItems: alignItems,
    justifyContent: 'space-between',
    className: styles('file-upload-container')
  }, _react.default.createElement(_flex.default, {
    direction: 'column',
    gap: 8
  }, title && typeof title === 'string' ? _react.default.createElement(_2.Text, {
    variant: 'medium'
  }, title) : title, subtitle && _react.default.createElement(_2.Text, {
    size: 13
  }, subtitle), error && _react.default.createElement(_2.Text, {
    dataTestId: dataTestId && `${dataTestId}-error`,
    className: styles('error-message'),
    size: 13,
    status: 'failed',
    text: errorText
  })), _react.default.createElement(_2.FileUploadButton, {
    className: styles({
      'file-upload-button': isFlexDirectionColumn
    }),
    dataTestId: dataTestId && `${dataTestId}-file-upload`,
    variant: 'outlined',
    allowFilePassword: allowFilePassword,
    maxFileSize: maxFileSize,
    acceptedFiletypes: acceptedFiletypes,
    icon: isFlexDirectionColumn ? _2.IconEnum.upload : undefined,
    label: label ? label : 'Upload',
    onError: onError,
    onPasswordProtectedError: onPasswordProtectedError,
    onFilesChanged: files => {
      fileList.unshift(...files);
      setFileList([...fileList]);
      files.forEach(file => {
        file.setProgressCompletedCallback(() => {
          if (onFileProgressCompleted) {
            onFileProgressCompleted(file, fileList);
          }
        });

        if (onFileAdded) {
          onFileAdded(file, fileList);
        }
      });
    }
  })), _react.default.createElement(_2.Expandable, {
    expand: fileList.length > 0 || (previouslyUploadedFiles ? previouslyUploadedFiles.length > 0 : false)
  }, _react.default.createElement("div", {
    className: styles('file-upload-results')
  }, previouslyUploadedFiles === null || previouslyUploadedFiles === void 0 ? void 0 : previouslyUploadedFiles.map((fileName, i) => {
    return _react.default.createElement("div", {
      className: styles('result-row'),
      key: i
    }, _react.default.createElement("div", {
      key: i,
      className: styles('result-row-name')
    }, _react.default.createElement(_flex.default, null, _react.default.createElement(_2.Icon, {
      name: _2.IconEnum.up_arrow
    }), _react.default.createElement(_2.Text, {
      variant: `medium`,
      color: _2.Color.neutral._80,
      className: styles('file-name'),
      text: fileName
    }))));
  }), fileList.map(file => {
    return _react.default.createElement("div", {
      className: styles('result-row'),
      key: file.vid
    }, _react.default.createElement("div", {
      key: file.vid,
      className: styles('result-row-name', {
        'in-progress': !file.error && !file.isUploaded
      })
    }, _react.default.createElement(_2.Content, {
      flex: true,
      alignItems: `center`
    }, file.error ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_2.Icon, {
      name: _2.IconEnum.exclamation_triangle,
      color: _2.Color.semantic.$error50
    }), _react.default.createElement(_2.Text, {
      variant: `medium`,
      status: `failed`,
      dataTestId: dataTestId && `${dataTestId}-file-upload-failed-${_lodash.default.kebabCase(file.name)}`,
      text: file.name,
      className: styles('file-name')
    })) : file.isUploaded ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_2.Icon, {
      name: _2.IconEnum.check_circle,
      color: _2.Color.semantic.$success50
    }), _react.default.createElement(_2.Text, {
      variant: `medium`,
      status: `success`,
      className: styles('file-name'),
      dataTestId: dataTestId && `${dataTestId}-file-upload-success-${_lodash.default.kebabCase(file.name)}`,
      text: file.name
    })) : _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_2.Icon, {
      name: _2.IconEnum.up_arrow
    }), _react.default.createElement(_2.Text, {
      variant: `medium`,
      color: _2.Color.neutral._80,
      className: styles('file-name'),
      text: file.name
    }))), file.error ? _react.default.createElement(_2.Text, {
      className: styles('result-row-info'),
      status: `failed`,
      text: file.error
    }) : file.isUploaded ? _react.default.createElement(_2.RelativeTimeText, {
      className: styles('result-row-info'),
      color: _2.Color.neutral._60,
      startDate: file.uploadCompletedAt || new Date(),
      granularity: 'minutes'
    }) : _react.default.createElement(_2.Expandable, {
      expand: file.visualProgress > 0
    }, _react.default.createElement(_2.ProgressBar, {
      variant: `dark`,
      size: `small`,
      progress: file.visualProgress
    }))), _react.default.createElement(_2.Link, {
      dataTestId: dataTestId && `${dataTestId}-file-abort-link-${file.vid}`,
      text: file.error || file.isUploaded ? `Remove` : `Cancel`,
      onClick: () => removeFile(file)
    }));
  }))));
});
var _default = FileUpload;
exports.default = _default;